import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import type { FunctionComponent } from 'react';
import { Fragment, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { MainHeadlineSubPage } from '../../../design/components/Typography';
import { SearchTable } from './SearchTable';

const Headline: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    const globalSearchHeadline = translate('pages.global-search.search-headline');

    return (
        <Grid alignContent="center" container={true} sx={{ pb: 3, pt: 6 }}>
            <Container>
                <MainHeadlineSubPage>{globalSearchHeadline}</MainHeadlineSubPage>
            </Container>
        </Grid>
    );
};

export const GlobalSearchPage: FunctionComponent = () => (
    <Fragment>
        <Headline />
        <Container>
            <SearchTable />
        </Container>
    </Fragment>
);
